<template>

  <div class="h-full font-sans">

    <Top></Top>

    <div class="flex h-full" @mouseup="endDragging()">

      <div class="h-full" :style="{width: `${sidebarWidth}%`}">
        <Sidebar></Sidebar>
      </div>

      <div class="divider" :style="{left: `${sidebarWidth}%`}" @mousedown="startDragging()"></div>

      <div :style="{width: `${100 - sidebarWidth}%`}">
        <div class="p-6 pt-16">
          <router-view></router-view>
        </div>
      </div>

    </div>
    
  </div>

</template>

<script>
  import { mapState } from 'vuex'
  import Sidebar from '@/components/Sidebar.vue'
  import Top from '@/components/Top.vue'

  export default {

    data() {
      return {
        minSidebarWidth: 11,
        maxSidebarWidth: 40
      }
    },

    computed: {
      ...mapState({
          sidebarWidth: state => state.config.sidebarWidth,
          currentUser: state => state.user.info,
          currentUserMarktimes: state => state.user.marktimes
      }),
    },

    components: {
      Sidebar,
      Top,
    },

    methods: {
      saveSidebarWidth(size) {
        this.$store.commit('config/SET_SIDEBAR_WIDTH', size)
      },

      handleDragging (e) {
        const percentage = (e.pageX / window.innerWidth) * 100

        if(e.stopPropagation) e.stopPropagation()
        if(e.preventDefault) e.preventDefault()

        if (percentage >= this.minSidebarWidth && percentage <= this.maxSidebarWidth) {
          this.$store.commit('config/SET_SIDEBAR_WIDTH', percentage.toFixed(2))
        }
      },

      startDragging () {
        document.addEventListener('mousemove', this.handleDragging)
      },

      endDragging () {
        document.removeEventListener('mousemove', this.handleDragging)
      },


    },

    async created() {
      if (!this.currentUser) await this.$store.dispatch('user/getUser');
      if (!this.currentUserMarktimes) await this.$store.dispatch('user/getMarktimes');
    }

  }
</script>

<style lang="scss">
  .divider {

    &:before {
      display: block;
      content: "";
      width: 3px;
      height: 40px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -20px;
      margin-left: 3px;
      border-left: 1px solid #888;
      border-right: 1px solid #888;
    }

    height: 100vh;
    width: 9px;
    background: transparent;
    transform: translateX(-3px);
    position: absolute;
    top: 0;
    z-index: 99999;
    cursor: col-resize;
  }
</style>